const defaultOptions = {};
export class SWIC11Admin {
    constructor(adminDashboard) {
        this.options = defaultOptions;
        this.$adminDashboard = $(adminDashboard);
        this.$selectors = $('select');
        this.$adminDashboard.find('select').select2({
            minimumResultsForSearch: Infinity
        });
        const self = this;
        $.each(this.$selectors, function (i, dash) {
            $(dash).change(b => {
                let selectedClass = ".swic11-admin-dash-select-" + $(dash).attr("data-value") + $(this).val();
                $('.swic11-admin-dash-select-all1').hide();
                $('#managersoverstores').html("- / -");
                $('#totalreps').html("-");
                $('#overfour').html("-");
                let visible;
                if ($(this).val() == 0) {
                    $(".swic11-admin-dash-select-all1").fadeIn();
                    visible = $('#swic11-dashboard').find(".swic11-admin-dash-select-all1");
                }
                else {
                    $(selectedClass).fadeIn();
                    visible = $('#swic11-dashboard').find(selectedClass);
                }
                let managers = 0;
                let totalstores = 0;
                let totalreps = 0;
                let totaloverfour = 0;
                $.each($(visible), function (i, store) {
                    totalstores++;
                    totalreps += parseInt($(store).attr("data-rsps"));
                    managers += $(store).attr("data-manager") == "True" ? 1 : 0;
                    totaloverfour += $(store).attr("data-overfour") == "True" ? 1 : 0;
                });
                $('#managersoverstores').html(managers.toLocaleString("en") + "/" + totalstores.toLocaleString("en"));
                $('#totalreps').html(totalreps.toLocaleString("en"));
                $('#overfour').html(totaloverfour.toString());
                $.each(self.$selectors, function (i, d) {
                    if ($(dash).attr("data-value") != $(d).attr("data-value")) {
                        $(d).val('0');
                    }
                });
            });
        });
    }
}
const c = {};
$(".swic11-admin-dashboard").each((i, elem) => {
    c[i] = new SWIC11Admin(elem);
});
